const postBirthData = {
  version: 1,
  lang: "kr",
  datas: [
    {
      day: 1,
      mom: {
        head: {
          title: "엄마, 정말 수고 많으셨어요!",
          discribed: "세상에 나온 아기와의 첫날, 축하드려요!",
        },
        body: [
          {
            subTitle: "오늘 엄마의 몸에 일어나는 일들",
            discribed:
              "- 오로가 나와요\n출산 직후 자궁에서 혈액·점액·조직이 배출되는 것을 오로라고 해요.\n\n처음엔 선홍빛에 가까우며 점차 갈색, 노란빛으로 변하다 4~6주 내에 사라져요.\n\n- 자궁수축과 산후통이 있어요\n출산 후 자궁이 줄어들면서 생리통 같은 통증이 나타날 수 있어요.\n\n쌍태아 엄마, 다산부, 모유수유 중인 경우엔 산후통이 더 심하게 느껴질 수 있어요.\n\n- 회음부나 수술 부위가 아파요\n자연분만 후 회음부 절개 부위가, 제왕절개 후에는 배의 수술 부위가 아플 수 있어요.\n\n너무 무리하지 말고, 몸을 따뜻하게 유지하며, 휴식이 회복의 열쇠라는 점 잊지 마세요.",
          },
          {
            subTitle: "모유수유, 아직 어색해도 괜찮아요",
            discribed:
              "오늘부터 아기에게 초유를 먹이게 되죠.\n\n초유는 양은 적지만 영양은 아주 풍부해요.\n\n빠는 힘이 약한 쌍둥이 아기나 미숙아는 도움을 받으며 수유 연습을 해요.\n\n너무 아프거나 유방이 단단해질 땐, 간호사나 전문가에게 꼭 도움을 요청해주세요.",
          },
          {
            subTitle: "오늘의 회복 팁",
            discribed:
              "너무 오랫동안 서 있지 않기, 통증이 심하면 간호사에게 이야기하기.\n\n좌욕이나 따뜻한 물수건을 이용해 회음부 주변을 부드럽게 관리하면 통증 완화에 도움이 돼요.\n\n회음부 통증이 있거나 자궁 수축통이 심할 땐 좌욕이나 따뜻한 찜질이 도움이 될 수 있어요.\n\n단, 찜질팩은 수건으로 감싸 피부에 직접 닿지 않도록 하고, 저온 화상에 주의하세요.",
          },
        ],
      },
      baby: {
        head: {
          title: "세상에 온 지 하루 된 아기",
          discribed: "이 작은 몸에도 변화가 가득해요.",
        },
        body: [
          {
            subTitle: "탯줄 관리",
            discribed:
              "아기의 배꼽에는 아직 탯줄이 붙어 있을 거예요.\n\n1~2주 안에 저절로 떨어지니 손으로 건드리지 말고 마른 상태를 유지해주세요.\n\n기저귀는 탯줄을 덮지 않도록 접어서 채우는 게 좋아요.",
          },
          {
            subTitle: "첫 변과 체온 조절",
            discribed:
              "처음 보는 아기의 변이 시커멓고 끈적해도 놀라지 마세요.\n\n'태변'이라 불리는 정상적인 첫 변이에요.\n\n2~3일 안에 점점 초록빛에서 황금빛으로 바뀌어요.\n\n손발이 차가울 수 있어요.\n\n이는 아직 체온 조절이 완벽하지 않기 때문이며, 몸통이 따뜻하면 걱정하지 않아도 돼요.",
          },
          {
            subTitle: "환경 적응",
            discribed:
              "아기에게는 아직 모든 게 낯설고 혼란스러워요.\n\n낮엔 조용한 빛과 소리, 밤엔 어둡고 차분한 공간이 필요해요.\n\n오늘도 잘 적응 중이에요. 걱정하지 마세요.",
          },
        ],
      },
      dad: {
        head: {
          title: "아빠, 당신도 이제 진짜 아빠예요",
          discribed: "엄마 곁에 든든히 있어주세요.",
        },
        body: [
          {
            subTitle: "아내 돌보기",
            discribed:
              "아내의 몸은 여전히 통증과 출혈, 수축으로 힘든 상태예요.\n\n몸을 일으킬 때도 도와주고, 모유 수유 후 유축이나 유방 마사지 등 엄마가 힘들어하는 부분을 자연스럽게 도와주세요.",
          },
          {
            subTitle: "정서적 지지",
            discribed:
              "병원에 면회가 허용되지 않는 경우, 따뜻한 톡 하나, 영상통화 한 번이 큰 힘이 될 수 있어요.\n\n'잘하고 있어.' '정말 수고했어.' 그 한 마디가 피로를 덜어줍니다.",
          },
          {
            subTitle: "아기에 대한 걱정",
            discribed:
              "아기 사진을 볼 땐 감탄보다 걱정이 먼저일 수도 있어요.\n\n너무 작아 보이고, 울기만 하고, 손발이 차가운 것 같고…\n\n대부분은 정상 발달 과정이니 엄마와 의료진의 설명을 신뢰하고 지켜보는 마음이 중요해요.\n\n오늘의 키워드: 지지와 신뢰.\n\n오늘 하루, 무조건 아내의 편이 되어주세요.\n\n그리고 자신에게도 속으로 말해주세요. '나도 잘하고 있어.'",
          },
        ],
      },
    },
    {
      day: 2,
      mom: {
        head: {
          title: "몸도 마음도 아직 어지러운 하루",
          discribed: "천천히 회복해도 괜찮아요.",
        },
        body: [
          {
            subTitle: "출산 이틀째 몸의 변화",
            discribed:
              "출산 이틀째가 되는 오늘, 분만 종류와 상관없이 몸의 변화가 본격적으로 느껴지기 시작해요.\n\n자궁 수축에 의한 통증(후진통), 오로 배출, 회음부나 수술 부위 통증이 지속될 수 있어요.",
          },
          {
            subTitle: "후진통과 통증 관리",
            discribed:
              "후진통은 자궁이 임신 전 크기로 돌아가는 자연스러운 과정이지만 수축통처럼 느껴져요.\n\n특히 수유 중 더 심해질 수 있어요.\n\n자궁수축과 통증 완화를 위해 수유 전 따뜻한 찜질팩을 배 위에 얹는 것이 도움이 될 수 있어요.\n\n이때는 반드시 수건으로 감싸 피부에 직접 닿지 않도록 하고, 저온 화상을 주의해주세요.",
          },
          {
            subTitle: "감정의 변화",
            discribed:
              "마음이 울컥하거나, 눈물이 나기도 해요.\n\n자연스러운 변화예요.\n\n오늘은 있는 그대로의 나를 다정하게 안아주세요.",
          },
        ],
      },
      baby: {
        head: {
          title: "아기의 하루하루는 경이로움의 연속이에요",
          discribed: "",
        },
        body: [
          {
            subTitle: "체중 변화와 수면 패턴",
            discribed:
              "출생 후 이틀째인 오늘, 아기는 여전히 깊고 짧은 수면을 반복하며 세상과 적응 중이에요.\n\n첫 2-3일간 체중이 출생 시보다 5-7% 정도 감소하는 건 정상이에요.\n\n수분이 빠져나가면서 자연스러운 현상이니 너무 걱정하지 않아도 괜찮아요.",
          },
          {
            subTitle: "탯줄과 수유",
            discribed:
              "배꼽(탯줄)은 아직 떨어지지 않았을 수 있어요.\n\n기저귀가 닿지 않도록 조심하고, 물에 젖지 않게 관리해주세요.\n\n수유 후 토해내는 듯한 '게워냄'은 흔한 일이지만, 분수처럼 토하거나 얼굴이 파래지는 경우엔 의료진에게 알려주세요.",
          },
          {
            subTitle: "성장의 기록",
            discribed:
              "작은 숨결 하나도, 눈빛 하나도 소중한 기록이 되는 시기예요.\n\n아기만의 리듬을 존중하면서, 조심스럽게 함께해 주세요.",
          },
        ],
      },
      dad: {
        head: {
          title: "이 시기의 아내와 아기를 지켜보는 당신, 정말 든든합니다",
          discribed: "",
        },
        body: [
          {
            subTitle: "실질적 도움",
            discribed:
              "출산 직후부터 아내의 몸은 하루가 다르게 달라지고 있어요.\n\n산후 통증과 수유로 몸과 마음이 지쳐있는 시기예요.\n\n직접 아기를 안아주고, 기저귀 갈기, 속싸개 정리, 젖병 소독 등 아빠의 역할이 많아졌어요.\n\n작지만 실질적인 도움이 큰 위안이 돼요.",
          },
          {
            subTitle: "아기와의 시간",
            discribed:
              "아내가 쉬는 동안 아기와 시간을 보내보는 것도 좋아요.\n\n눈을 마주치며 낮고 부드럽게 말 걸어주는 것만으로도 충분해요.\n\n말없이 옆에 있어주는 것만으로도 큰 위로가 되는 날이에요.\n\n'내가 곁에 있어.' 이 한마디가 아내에게는 세상의 어떤 말보다 힘이 될 수 있어요.\n\n고생 많았어요, 아빠!",
          },
        ],
      },
    },
    {
      day: 3,
      mom: {
        head: {
          title: "조금씩 내 몸이 돌아오고 있어요",
          discribed: "아직은 회복이 우선이에요.",
        },
        body: [
          {
            subTitle: "출산 3일째 몸의 상태",
            discribed:
              "출산 3일째, 몸과 마음이 조금 더 현실을 느끼게 되는 시기예요.\n\n자궁 수축과 오로 배출은 여전히 계속되고 있어요.\n\n양이 많거나 냄새, 색이 이상한 경우에는 꼭 의료진에게 알려주세요.",
          },
          {
            subTitle: "활동과 수유",
            discribed:
              "수술 부위나 회음부 통증은 활동량에 따라 심해질 수 있어요.\n\n오늘은 잠깐 병실 복도를 걷는 정도로만 움직여 보세요.\n\n수유는 하루 8~12회, 짧고 자주 아기와 접촉하는 수유 패턴이 정착되기 시작해요.",
          },
          {
            subTitle: "마음가짐",
            discribed:
              "오늘만큼은 내 몸이 회복하고 있다는 신호에 집중해 주세요.\n\n다른 엄마들과 비교하지 않아도 괜찮아요.\n\n엄마의 회복 속도는, 당신만의 시간표로도 충분히 아름다워요.",
          },
        ],
      },
      baby: {
        head: {
          title: "낯선 세상에 조금씩 적응해가요",
          discribed: "",
        },
        body: [
          {
            subTitle: "수면과 활동 패턴",
            discribed:
              "태어난 지 3일째인 아기는 여전히 깊은 수면 – 울음 – 수유 – 배변의 리듬을 반복하고 있어요.",
          },
          {
            subTitle: "황달과 배변",
            discribed:
              "황달이 눈이나 얼굴에 보일 수 있어요.\n\n생리적 황달은 대부분 생후 3~5일 사이에 나타났다가 자연스럽게 사라지니, 의료진의 지시에 따라 관찰만 해주세요.\n\n첫 태변 이후 점차 노란색으로 바뀌는 아기 변은 소화기관이 잘 작동하고 있다는 신호예요.",
          },
          {
            subTitle: "탯줄 관리",
            discribed:
              "탯줄은 아직 남아있을 수 있어요.\n\n배꼽 주변이 붉거나 냄새가 나면 반드시 진료가 필요해요.\n\n작은 변화 하나에도 민감한 시기지만, 걱정보다는 관찰과 기록이 도움이 되는 시점이에요.\n\n오늘 하루 아기와 눈 마주치는 시간이 조금 더 늘어났기를 바라요.",
          },
        ],
      },
      dad: {
        head: {
          title: "이제 실전 육아, 본격적으로 시작입니다!",
          discribed: "",
        },
        body: [
          {
            subTitle: "퇴원 준비",
            discribed:
              "출산 직후의 혼란스러움이 조금은 가라앉고, 이제부터 본격적인 '함께 돌봄'의 시작점이 다가오고 있어요.\n\n병원에서 퇴원 시 아기 수유 방법, 배꼽 소독, 목욕 전 준비물 등을 설명해주는 경우가 많아요.\n\n잘 듣고, 메모하거나 사진으로 남겨두세요.",
          },
          {
            subTitle: "분업과 도움",
            discribed:
              "아내의 수유 시간표를 함께 파악하고, 간식이나 물 챙기기, 수유 후 트림 시키기, 기저귀 갈기 등 분업해보세요.\n\n특히 아내가 걱정하거나 불안해하는 부분이 무엇인지 살펴보고 '내가 도와줄게'라는 말보다 먼저 행동으로 보여주는 게 좋아요.",
          },
          {
            subTitle: "마음가짐",
            discribed:
              "그리고 꼭 기억해 주세요. '완벽하지 않아도 괜찮다.'\n\n처음이니까 서툰 게 당연해요.\n\n지금 이 순간, 함께하고 있다는 것만으로도 이미 멋진 아빠예요.",
          },
        ],
      },
    },
    {
      day: 4,
      mom: {
        head: {
          title: "조금씩 일상이 다가오는 기분… 하지만 아직은 '회복 중'이에요",
          discribed: "",
        },
        body: [
          {
            subTitle: "자연분만의 경우",
            discribed:
              "회음부 통증이 점점 줄어들고 있고 오로의 양은 줄지만 색이 진해지거나 다시 많아질 수 있어요.\n\n앉았다 일어날 때, 허리를 숙일 때 허리나 회음부의 불편감이 있다면 무리하지 말고 천천히 움직이세요.\n\n퇴원 전이라면 산후조리계획, 오로 상태, 유방 관리법 등을 의료진에게 충분히 질문하세요.",
          },
          {
            subTitle: "제왕절개의 경우",
            discribed:
              "복부 절개 부위가 아직 민감하기 때문에 무리한 체위 변경은 금물.\n\n걷기나 움직임이 가능해졌더라도, 아직 일상 복귀는 무리.\n\n수유 자세도 복부에 부담을 덜 주는 옆으로 눕는 자세가 좋아요.\n\n배액관이 빠졌다면 상처 부위 상태를 확인하고, 샤워 여부는 꼭 의료진과 상의하세요.",
          },
          {
            subTitle: "공통 팁",
            discribed:
              "유방이 단단하고 열감이 있을 경우, 유선이 막혔을 수 있어요.\n\n따뜻한 수건으로 유방 전체를 감싸듯 찜질하고, 부드럽게 마사지해주세요.\n\n단, 찜질은 화상에 주의해 수건이나 천을 한 겹 덧대어 사용해야 해요.\n\n퇴원 전이라면, 산모수첩이나 배변/수유/통증 등의 상태를 간단히 메모해 두는 것도 도움이 돼요.",
          },
        ],
      },
      baby: {
        head: {
          title: "저는 지금 엄마와 함께 세상 적응 중이에요",
          discribed: "",
        },
        body: [
          {
            subTitle: "수면과 반응",
            discribed:
              "아기는 여전히 하루 중 대부분을 잠으로 보내고 있어요.\n\n하지만 눈을 뜬 채 엄마 얼굴을 바라보거나, 소리에 고개를 돌리거나, 손발을 움찔움찔 움직이는 반응을 보이기도 해요.",
          },
          {
            subTitle: "소화와 배변",
            discribed:
              "배앓이처럼 불편함에 찡그리는 표정을 보일 수 있어요.\n\n이 시기에는 소화 능력이 아직 미숙하므로 분유 양 조절, 수유 후 트림, 배 마사지나 자세 교정이 도움이 될 수 있어요.\n\n(단, 복부를 세게 누르지 않도록 주의하세요.)\n\n대변이 하루 4~10회까지도 나올 수 있으며, 황금색/연녹색 점액변은 비교적 정상이에요.",
          },
          {
            subTitle: "관찰과 기록",
            discribed:
              "변비나 설사처럼 보여도 아기에게 일반적인 패턴일 수 있으니 배변 패턴을 며칠 관찰한 뒤 변화가 지속되면 진료상담을 추천드려요.",
          },
        ],
      },
      dad: {
        head: {
          title: "아빠는 지금 '돌봄의 근육'을 키우는 중이에요",
          discribed: "",
        },
        body: [
          {
            subTitle: "아기와의 관계 형성",
            discribed:
              "이제 아기는 아빠의 손길을 기억하기 시작해요.\n\n매일 하는 기저귀 갈이, 수유 보조, 아기 목욕 준비 같은 일들은 반복될수록 아빠와 아기의 친밀감을 쌓는 순간이 돼요.",
          },
          {
            subTitle: "아내 도움",
            discribed:
              "제왕절개로 아직 회복 중인 아내에게는 침대에서 일어나는 것조차 어려운 일이에요.\n\n기저귀나 물티슈, 아기옷, 젖병 등을 손 닿는 곳에 미리 준비해두는 습관, 아기 우는 소리를 먼저 듣고 아내보다 먼저 일어나보는 배려가 큰 힘이 돼요.",
          },
          {
            subTitle: "구체적인 도움",
            discribed:
              "아내가 모유 수유에 힘들어할 때, '내가 뭐라도 도와줄게'보다 '수유 끝나면 내가 트림시키고 안아줄게'처럼 구체적인 도움 표현이 훨씬 효과적이에요.\n\n아내에게, 그리고 아기에게 '나는 지금 이 가족의 가장 든든한 조력자'라는 마음으로 함께해 주세요!",
          },
        ],
      },
    },
    {
      day: 5,
      mom: {
        head: {
          title: "조금은 익숙해지고, 여전히 조심스러운 회복기예요",
          discribed: "",
        },
        body: [
          {
            subTitle: "자연분만 산모의 경우",
            discribed:
              "집에서 산후조리를 시작한 경우가 많고 아직 회음부 통증, 오로 배출, 유방 통증이 남아 있어요.\n\n장시간 서 있거나 앉아 있는 것보다는 가벼운 걷기와 충분한 휴식이 좋아요.",
          },
          {
            subTitle: "제왕절개 산모의 경우",
            discribed:
              "여전히 병원 입원 중인 경우가 많고, 복부 절개부의 당김, 통증, 기침 시 불편함이 이어질 수 있어요.\n\n퇴원 전까지는 배뇨 상태, 복부 상처 상태, 유즙 분비 여부 등을 의료진에게 꼭 체크받으세요.",
          },
          {
            subTitle: "주의사항",
            discribed:
              "오로는 점점 양이 줄고 색이 옅어지고 있어요.\n\n만약 불쾌한 냄새, 덩어리, 심한 복통이 동반된다면 감염 가능성이 있으니 의료진에게 바로 상담하세요.\n\n몸이 점차 붓거나, 부종이 빠지지 않고 더 심해진다면 수분 섭취와 짠 음식 줄이기를 시도해 보되, 지속된다면 검진이 필요해요.",
          },
          {
            subTitle: "격려",
            discribed:
              "오늘도 회복 중인 내 몸을 향한 응원 잊지 마세요.\n\n'어제보다 한 발 더 나아간 나, 정말 잘하고 있어요!'",
          },
        ],
      },
      baby: {
        head: {
          title: "이제 제 눈빛도, 울음도 의미가 있어요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "발달 상황",
            discribed:
              "아기는 여전히 잠이 많은 상태지만, 눈을 뜨고 있는 시간도 서서히 늘어나기 시작해요.\n\n이제 엄마·아빠의 목소리에 고개를 돌리거나 울음을 통해 자신의 의사를 표현해요.",
          },
          {
            subTitle: "울음은 신호예요!",
            discribed:
              "배고프거나, 기저귀가 젖었거나, 너무 덥거나 추워도 울음으로 표현해요.\n\n아직 분명한 이유를 알 수 없어도 괜찮아요.\n\n아기의 울음은 부모가 아기와 소통하는 가장 중요한 방법이에요.",
          },
          {
            subTitle: "시각과 언어 발달",
            discribed:
              "아직 목 근육은 약하지만, 신생아는 엄마·아빠의 얼굴을 20~30cm 거리에서 가장 잘 인식해요.\n\n표정도 따라하려는 시도를 할 수 있어요.\n\n아기와 눈을 맞추고 부드럽게 이야기해 주세요.\n\n이런 시간들이 언어와 정서 발달의 시작이랍니다.",
          },
          {
            subTitle: "수유량 관리",
            discribed:
              "분유 또는 모유 양이 갑자기 늘지 않아도 걱정 마세요.\n\n수유량보다 수유 간격, 아기 배변 패턴, 기분 상태 등을 함께 지켜보는 것이 중요해요.",
          },
        ],
      },
      dad: {
        head: {
          title: "지금은 돌봄 파트너로서 아빠가 빛나는 시간이에요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "엄마는 아직 회복 중이에요",
            discribed:
              "자연분만이든 제왕절개든 몸의 통증, 불편한 자세에서의 수유, 계속되는 수면 부족은 엄마에게 큰 부담이 돼요.\n\n아빠는 이럴 때일수록 엄마가 '혼자 애 키우는 느낌'을 느끼지 않게 해줘야 해요.",
          },
          {
            subTitle: "격려의 말",
            discribed:
              "'지금도 충분히 잘하고 있어.' '너무 힘들면 내가 바꿔줄게, 잠깐 쉬어.'\n\n이런 한마디가 엄마에게 엄청난 위로와 지지가 돼요.",
          },
          {
            subTitle: "아기와 시간 늘리기",
            discribed:
              "아기와 보내는 시간도 점점 늘려가 보세요.\n\n수유 후 트림 시키기, 목욕 준비, 아기 안아주기 등 '잘하는 아빠'보다 '자주 보는 아빠'가 더 중요해요.\n\n매일 반복되는 일상이 곧 아빠와 아기의 애착을 만드는 시간이랍니다.",
          },
        ],
      },
    },
    {
      day: 6,
      mom: {
        head: {
          title: "몸도 마음도 천천히 회복 중이에요",
          discribed: "",
        },
        body: [
          {
            subTitle: "자연분만을 했다면",
            discribed:
              "회음부 통증이 줄었는지 확인해보세요.\n\n간혹 실밥 부위에 붓기나 감염 증상이 느껴진다면 꼭 진료를 받아야 해요.\n\n자연스러운 변이나 소변 볼 때의 통증이 점차 나아지고 있다면 정상 회복 중이에요.",
          },
          {
            subTitle: "제왕절개를 했다면",
            discribed:
              "상처 부위가 가렵거나 묵직한 느낌이 들 수 있어요.\n\n절개 부위가 너무 땅기거나 열감이 있으면 감염이 아닌지 확인이 필요해요.\n\n실밥 제거 예정일은 꼭 병원과 상담하세요.",
          },
          {
            subTitle: "공통적으로 필요한 회복 팁",
            discribed:
              "-너무 오래 서 있거나 무거운 물건을 들지 말기\n\n-의자에 앉을 땐 둔부 전체를 지지하고 천천히 일어서기\n\n-밤중 수유 후에는 누워서 10분 정도라도 쉬기",
          },
          {
            subTitle: "감정 관리",
            discribed:
              "그리고, 아직 감정이 오르락내리락할 수 있어요.\n\n그럴 땐 꼭 '이건 내가 이상한 게 아니라 자연스러운 회복의 일부'라는 걸 기억하세요.\n\n'지금도 충분히 잘하고 있어요!'",
          },
        ],
      },
      baby: {
        head: {
          title: "하루가 다르게 커가고 있어요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "성장과 발달",
            discribed:
              "아기는 하루하루 성장하고 있어요.\n\n수유 후 트림도 전보다 더 잘하고, 자극에 반응하는 시간도 조금씩 늘어나고 있어요.",
          },
          {
            subTitle: "수유와 배변",
            discribed:
              "수유는 여전히 2-3시간 간격, 수유량은 아기의 컨디션에 따라 달라질 수 있어요.\n\n하루 기저귀를 6-8회 이상 갈고 있다면 잘 먹고 있다는 신호!",
          },
          {
            subTitle: "감각 자극 관리",
            discribed:
              "아기가 잘 울다가, 금세 멍하니 있을 때가 있어요.\n\n이건 피로하거나 감각에 과하게 자극받았을 때예요.\n\n이럴 땐 조용한 공간에서 안아주는 것만으로도 안정이 돼요.\n\n아기의 눈은 아직 초점이 맞지 않지만, 소리와 빛에 민감하게 반응하고 있어요.\n\n자극은 짧고 부드럽게, 눈맞춤은 20~30cm 거리에서 해주세요.",
          },
        ],
      },
      dad: {
        head: {
          title: "이제부터는 실전 돌봄의 시간!",
          discribed: "",
        },
        body: [
          {
            subTitle: "전담 돌봄 시간",
            discribed:
              "이제는 정말 아빠의 손이 더 필요한 시기예요.\n\n엄마가 휴식을 취할 수 있도록 하루 중 적어도 한 번은 전담 돌봄 시간을 맡아주세요.",
          },
          {
            subTitle: "아빠만의 돌봄 루틴",
            discribed:
              "기저귀를 갈고, 수유 후 트림을 시키고, 아기를 안고 창밖을 보여주며 짧은 산책 같은 시간을 보내보세요.",
          },
          {
            subTitle: "서툴러도 괜찮아요",
            discribed:
              "아기의 울음과 표정을 읽는 데 서툴러도 괜찮아요.\n\n'조금 어색해도 자주 해보는 게 실력!'\n\n처음부터 잘하는 아빠보다, 계속 시도하는 아빠가 멋진 아빠예요.\n\n오늘 밤도 혹시 아기가 오래 울게 된다면 엄마 혼자 감당하지 않도록 함께 번갈아 안아주고, 쉬는 시간을 배려해주세요.",
          },
        ],
      },
    },
    {
      day: 7,
      mom: {
        head: {
          title: "출산 후 첫 일주일, 정말 잘 버텨냈어요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "자연분만 후",
            discribed:
              "회음부 통증이 덜해졌다면 순조로운 회복 중이에요.\n\n하지만 앉거나 기침할 때 통증이 계속된다면 자세나 좌욕 관리가 필요한 시기예요.\n\n아직은 무리하지 말고 부드러운 자세로 움직이기!",
          },
          {
            subTitle: "제왕절개 후",
            discribed:
              "절개 부위의 통증이 둔하게 이어질 수 있어요.\n\n앉을 때·일어설 때 상체를 먼저 움직이지 않도록 주의해주세요.\n\n상처 주변이 붓거나 진물이 나면 병원에 꼭 문의하세요.",
          },
          {
            subTitle: "공통적으로…",
            discribed:
              "이 시기엔 몸의 호르몬 변화가 심해져 이유 없는 울컥함, 무기력함이 생기기도 해요.\n\n이건 산후우울증이 아니라 자연스러운 감정 곡선이에요.\n\n'지금 이만큼 해내고 있는 나, 참 대단하다'고 스스로에게 말해주세요.",
          },
        ],
      },
      baby: {
        head: {
          title: "우리 아기는 지금, 부모와의 유대감을 쌓는 중이에요",
          discribed: "",
        },
        body: [
          {
            subTitle: "학습과 유대감 형성",
            discribed:
              "신생아의 하루는 '수유–잠–기저귀–관찰'의 반복 같지만, 사실 그 안에서 아기는 계속 학습하고 있어요.\n\n수유 중, 아기는 엄마의 얼굴을 보며 유대감을 형성해요.\n\n가능하면 수유 중 아이와 눈을 맞추며 말 걸기 추천해요!",
          },
          {
            subTitle: "자극 조절",
            discribed:
              "하루 중 자극이 너무 많으면 과하게 울거나 멍하게 있어요.\n\n한 번에 여러 자극(불빛+소리+사람)을 주지 말고 한 번에 하나씩, 짧게, 반복적으로!",
          },
          {
            subTitle: "안전한 수면",
            discribed:
              "잠든 아기의 자세는 항상 반듯하게, 얼굴은 옆으로.\n\n엎드린 자세로 재우면 질식 위험이 커요.\n\n반드시 등을 대고 눕히기!",
          },
          {
            subTitle: "피부 관리",
            discribed:
              "이 시기부터 피부 트러블(태열, 땀띠)이 생기기 시작할 수 있어요.\n\n깨끗하게 씻기고, 면 소재 속옷과 가볍게 덮는 이불을 사용해주세요.",
          },
        ],
      },
      dad: {
        head: {
          title: "오늘도 아빠라는 이름으로, 연습 중입니다",
          discribed: "",
        },
        body: [
          {
            subTitle: "1주일째의 성과",
            discribed:
              "1주일째 아기를 돌보는 생활, '익숙해지기'보다는 '감당 중'이라는 말이 더 어울릴지도 몰라요.\n\n기저귀 갈기, 안아주기, 젖병 설거지... 작은 것도 잘 해냈어요.",
          },
          {
            subTitle: "분담의 중요성",
            discribed:
              "엄마와 교대해서 수유 후 트림 시키기, 안아주기, 기저귀 갈기를 하루 2회씩이라도 규칙적으로 분담해보는 것이 중요해요.",
          },
          {
            subTitle: "함께한다는 신호",
            discribed:
              "아빠에게 필요한 건 '완벽한 돌봄'이 아니라, 아내와의 '나는 함께하고 있어'라는 신호랍니다.",
          },
          {
            subTitle: "감정 이해하기",
            discribed:
              "요즘 들어 아내가 더 예민해졌다고 느끼나요?\n\n그건 엄마가 '지금도 회복 중'이라는 뜻이에요.\n\n아빠가 대화의 시작자가 되어주세요.\n\n'우리는 세 사람으로 완전체가 되어가는 중이에요.'\n\n하루하루, 더 멋진 아빠가 되어가고 있어요.",
          },
        ],
      },
    },
    {
      day: 8,
      mom: {
        head: {
          title: "엄마 몸, 조금씩 '제자리'로 돌아오는 중이에요",
          discribed: "출산 8일 차, 회복은 아직 '진행 중'이랍니다.",
        },
        body: [
          {
            subTitle: "자궁 수축통(후통)",
            discribed:
              "출산 직후보다 약해졌지만, 모유 수유 중 통증이 다시 느껴질 수 있어요.\n\n이는 자궁이 원래 크기로 돌아가기 위한 과정이니 너무 걱정 마세요.",
          },
          {
            subTitle: "질 분비물(오로)",
            discribed:
              "초기엔 선홍색이던 오로가 이제는 갈색~노란색으로 변화하고 있어요.\n\n불쾌한 냄새, 고름 같은 느낌, 열감이 있다면 즉시 진료받으세요.",
          },
          {
            subTitle: "제왕절개 산모의 경우",
            discribed:
              "아직 상처 부위가 간질간질하거나 욱신거릴 수 있어요.\n\n과한 움직임, 특히 물건 들기/계단 오르기는 삼가주세요.\n\n실밥을 제거했더라도 거즈를 자주 교체하고, 땀이 차지 않도록 해주세요.",
          },
          {
            subTitle: "회복의 마음가짐",
            discribed:
              "몸이 내는 신호에 귀 기울이며, '나는 회복 중이야'라고 스스로 인정하는 것도 회복의 한 과정이에요.",
          },
        ],
      },
      baby: {
        head: {
          title: "낮밤이 바뀌는 듯해도, 그 또한 성장의 과정이에요",
          discribed: "",
        },
        body: [
          {
            subTitle: "밤에 더 자주 깬다면?",
            discribed:
              "아기는 아직 '낮'과 '밤'을 구분할 수 없어요.\n\n낮에는 커튼을 열어 빛을 보여주고, 밤에는 조용하고 어두운 환경을 만들어 주세요.\n\n수유 후 눈을 마주치며 짧은 대화를 나누는 것도 낮과 밤을 구분하는 좋은 연습이에요.",
          },
          {
            subTitle: "배앓이 시작 전, 배 마사지 연습해요",
            discribed:
              "이제 곧 신생아 복통(가스, 배앓이)이 시작될 수 있는 시기예요.\n\n식후 10분쯤 지나면, 시계방향으로 부드럽게 배를 문질러주기!\n\n트림도 꼭꼭 시켜주는 게 좋습니다.",
          },
          {
            subTitle: "아기 손톱, 자를까 말까?",
            discribed:
              "이 시기 아기 손톱은 빠르게 자라요.\n\n얼굴을 긁는 경우가 있다면, 수면 중 가장 안정된 상태일 때 조심스럽게 손톱을 다듬어 주세요.\n\n아기 전용 손톱 가위나 사포형 손톱 다듬이 도구 사용 추천!",
          },
        ],
      },
      dad: {
        head: {
          title: "이제 밤이 두렵지 않다… 고 말하고 싶지만…",
          discribed: "",
        },
        body: [
          {
            subTitle: "새벽 육아의 시작",
            discribed:
              "아기가 자주 깨는 새벽, 아내도 힘들고, 아빠도 쉽지 않죠.\n\n오늘은 아내보다 5분 일찍 일어나 아기 기저귀를 갈아보세요.\n\n아내가 단 10분이라도 눈을 붙일 수 있게 도와주는 것, 그게 바로 아빠의 히어로 타임이에요.",
          },
          {
            subTitle: "말보다 행동",
            discribed:
              "아직 '어떻게 도와줘야 할지' 모르는 경우 '내가 해줄 수 있는 게 뭐가 있을까?' 이 질문보다 더 좋은 방법은, '아기 안고 있어볼게. 그동안 샤워하고 와.' '설거지해놨어. 얼른 누워.' 이처럼 행동으로 말하기!",
          },
          {
            subTitle: "아빠도 성장 중",
            discribed:
              "아빠도 지금, 출산 후 8일 차예요.\n\n매일매일 더 좋은 팀원이 되어가고 있어요.\n\n오늘의 작은 미션, 엄마에게 한 마디: '우리 지금 잘하고 있어. 고마워'",
          },
        ],
      },
    },
    {
      day: 10,
      mom: {
        head: {
          title: "천천히, 몸과 마음 모두 회복하는 중이에요",
          discribed:
            "출산 후 10일, 어느 정도 익숙해졌다고 느끼지만 아직 몸도 마음도 회복 중이랍니다.",
        },
        body: [
          {
            subTitle: "자궁 수축통은 자연스러운 회복의 과정이에요",
            discribed:
              "자궁은 임신 전 크기로 돌아가기 위해 계속 수축하고 있어요.\n\n특히 모유 수유 중에는 옥시토신이 분비돼 수축이 더 강해지면서 통증을 유발할 수 있어요.\n\n찜질팩을 수건에 싸서 아랫배에 올려두면 통증 완화에 도움이 될 수 있어요.\n\n단, 화상에 주의하세요!",
          },
          {
            subTitle: "제왕절개 산모라면?",
            discribed:
              "수술 부위 통증이 계속될 수 있어요.\n\n상처 부위를 늘어나게 하는 활동(갑자기 웃거나 무거운 짐 들기)은 피하고, 통증이 지속되거나 분비물이 많아지면 병원에 꼭 문의하세요.",
          },
          {
            subTitle: "감정이 롤러코스터처럼 오르내릴 수 있어요",
            discribed:
              "출산 직후엔 호르몬 변화, 수면 부족, 신체 회복과 육아의 스트레스가 겹치면서 갑자기 눈물이 나고, 무기력하거나 예민해지는 감정 기복이 생길 수 있어요.\n\n이건 산후 2주 이내에 흔히 나타나는 자연스러운 감정 곡선이에요.\n\n많은 산모들이 경험하고, 대부분은 시간이 지나면서 자연스럽게 회복돼요.",
          },
          {
            subTitle: "산후 우울증 신호 체크",
            discribed:
              "하지만 감정 기복이 2주 이상 지속되거나, 식욕이 사라지고, 잠들기 어렵거나, 아기에게 애착이 느껴지지 않고, 내가 너무 무가치하다고 느껴진다면 산후 우울증의 신호일 수 있어요.",
          },
          {
            subTitle: "도움 요청하기",
            discribed:
              "혼자서 참지 말고 남편, 가족, 친구에게 감정을 털어놓으세요.\n\n필요하다면 전문가(산후 상담, 정신건강의학과 등)의 도움을 받는 것도 좋은 방법이에요.\n\n엄마도 누군가에게 돌봄받아야 할 존재라는 사실, 절대 잊지 마세요.",
          },
        ],
      },
      baby: {
        head: {
          title: "우리 아기, 낮밤이 바뀌었나요?",
          discribed: "",
        },
        body: [
          {
            subTitle: "신생아는 낮과 밤의 개념이 없어요",
            discribed:
              "신생아는 생체리듬이 아직 완성되지 않아 낮밤이 바뀌는 것처럼 보일 수 있어요.\n\n낮에는 밝은 곳에서 활동하고, 밤에는 조명을 줄이고 조용한 분위기를 만들어 아기가 점차 밤에는 자고 낮에는 깨어 있도록 도와주세요.",
          },
          {
            subTitle: "아기의 눈 맞춤이 조금씩 길어져요",
            discribed:
              "이제 아기의 눈이 초점을 조금씩 맞추기 시작해요.\n\n눈을 바라보며 천천히 말을 걸어주세요.\n\n사랑이 담긴 엄마, 아빠의 목소리는 아기에게 큰 안정감을 줘요.",
          },
        ],
      },
      dad: {
        head: {
          title: "육아는 지금부터 진짜 시작이에요",
          discribed: "",
        },
        body: [
          {
            subTitle: "잠 부족한 아내를 위해 야간 근무를 도와주세요",
            discribed:
              "신생아는 여전히 자주 깨고, 밤낮 구분 없이 수유가 이어져요.\n\n한밤중에 깨는 아기에게 아빠가 기저귀를 갈아주고 엄마에게 데려다주는 것만으로도 큰 도움이 돼요.",
          },
          {
            subTitle: "몸조리 중인 아내, 말 한마디가 큰 위로가 돼요",
            discribed:
              "산후 회복은 생각보다 오래 걸려요.\n\n'힘들지?', '고마워', '내가 도울게' 따뜻한 말 한마디가 아내에게 큰 위로가 된답니다.",
          },
        ],
      },
    },
    {
      day: 13,
      mom: {
        head: {
          title: "내 몸과 아기에게 맞는 수유 방식이면 충분해요",
          discribed: "",
        },
        body: [
          {
            subTitle: "수유 방식에 대한 고민",
            discribed:
              "출산 후 2주, 아직 수유 리듬이 잡히지 않아 당황스러울 수 있어요.\n\n모유든 분유든, 혼합이든 가장 중요한 건 '엄마와 아기의 편안함'이에요.",
          },
          {
            subTitle: "모유수유 중이라면…",
            discribed:
              "수유 시 통증이 심하다면 유두 상처나 젖몸살일 수 있어요.\n\n부드러운 마사지나 찜질로 유방을 이완시키고, 필요시 유축기를 사용해보세요.\n\n제왕절개 산모는 옆으로 눕는 자세(사이드라이잉)가 회복에 부담을 덜 수 있어요.",
          },
          {
            subTitle: "분유수유 중이라면…",
            discribed:
              "아기와 눈을 마주치며 안아주는 시간 자체가 애착 형성에 큰 도움이 돼요.\n\n아기에게 맞는 젖병과 젖꼭지를 선택하고, 수유 중에 게워내거나 불편해하지 않는지 확인해 주세요.",
          },
          {
            subTitle: "혼합수유라면…",
            discribed:
              "수유 시간과 방식이 달라 엄마의 몸이 더 피곤할 수 있어요.\n\n규칙적인 수유 루틴과 수분 섭취, 휴식이 꼭 필요해요.",
          },
          {
            subTitle: "수유의 핵심",
            discribed:
              "수유의 방식보다 중요한 건 '내가 낼 수 있는 최선의 돌봄을 하고 있는가'예요.\n\n모든 엄마는 이미 충분히 잘하고 있어요.",
          },
        ],
      },
      baby: {
        head: {
          title: "아기의 하루가 점점 규칙을 찾아가요",
          discribed: "",
        },
        body: [
          {
            subTitle: "수면 패턴의 변화",
            discribed:
              "요즘 아기, 잠자는 시간이 조금씩 일정해지고 있나요?\n\n신생아의 하루는 여전히 수면과 수유의 반복이에요.\n\n수유 후 → 기저귀 갈기 → 조용한 환경 → 수면 같은 루틴을 반복해보세요.",
          },
          {
            subTitle: "밤낮 구분 돕기",
            discribed:
              "밤에는 조도와 소리를 줄여 '지금은 자는 시간'이라는 감각을 만들어 주세요.\n\n'언제 재워야 해요?'보다는 '어떻게 편하게 잘 수 있게 도와줄 수 있을까?'를 고민하는 게 더 중요해요.",
          },
        ],
      },
      dad: {
        head: {
          title: "수유는 육아의 중심이에요",
          discribed: "",
        },
        body: [
          {
            subTitle: "아빠도 수유 루틴에 함께 해주세요!",
            discribed:
              "모유수유든 분유수유든 아빠의 역할은 생각보다 크답니다.\n\n수유 중 편하게 기대거나 눕는 자세를 잡아주기, 수유 후 기저귀 갈기, 트림 시키기, 재우기 등 아기 돌보기, 엄마에게는 물 챙기기, 유축기 세척, 젖병 소독도 큰 도움이 돼요.",
          },
          {
            subTitle: "오늘의 한 줄 미션",
            discribed:
              "아내가 혼자 먹이고 돌보는 것이 아니라, 함께하는 수유가 되도록 곁에서 함께 있어주세요.",
          },
        ],
      },
    },
    {
      day: 17,
      mom: {
        head: {
          title: "아직 회복 중이에요. 느긋하게 가요",
          discribed: "",
        },
        body: [
          {
            subTitle: "현재 상태",
            discribed:
              "출산한 지 2주 반.\n\n내 몸은 온전히 회복되지 않았는데, 주변은 점점 '엄마 역할'을 기대해요.\n\n하지만 지금은 '엄마 역할'보다 '회복 중인 사람'에 가까워요.",
          },
          {
            subTitle: "회음부 통증/제왕절개 부위 불편감",
            discribed:
              "아직 앉거나 일어날 때 통증이 느껴질 수 있어요.\n\n따뜻한 좌욕이나 샤워로 순환을 도와주고, 무리한 움직임은 피하세요.\n\n제왕절개 후 상처는 가렵거나 당기는 느낌이 들 수 있어요.\n\n옷이 닿지 않도록 통풍에 신경 써주세요.",
          },
          {
            subTitle: "활동 범위 확장",
            discribed:
              "조금씩 바깥 공기를 쐬어도 좋아요.\n\n집 안에서도 창문을 열고 햇빛을 쐬는 것만으로 기분이 달라져요.\n\n가벼운 스트레칭이나 마사지도 회복에 도움이 돼요.",
          },
          {
            subTitle: "산후조리의 속도",
            discribed:
              "'산후조리'는 나만의 속도와 방식으로.\n\n느려도 괜찮아요.\n\n하루에 한 걸음만 내디뎌도 충분해요.",
          },
        ],
      },
      baby: {
        head: {
          title: "아기에게 '나만의 리듬'이 생기고 있어요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "루틴의 형성",
            discribed:
              "아기의 하루가 점점 자기만의 패턴을 만들어가고 있어요.\n\n수유→놀기→잠자는 루틴이 슬슬 자리 잡고 있나요?\n\n아직 밤낮 구분은 확실치 않지만, 밤에 조명을 줄이고 소리를 낮추면 아기에게 신호가 돼요.",
          },
          {
            subTitle: "이 시기의 꿀팁",
            discribed:
              "수유 후, 깨어 있을 때 아기의 눈을 마주치고 말을 걸어주세요.\n\n아기는 엄마 아빠의 목소리, 냄새, 터치로 세상을 익히고 있어요.\n\n아기에게 안정감을 주는 것 = 예측 가능한 반복적인 하루.\n\n너무 잘하고 있어요!",
          },
        ],
      },
      dad: {
        head: {
          title: "아내의 회복에도 루틴이 필요해요",
          discribed: "",
        },
        body: [
          {
            subTitle: "엄마의 루틴도 중요해요",
            discribed:
              "아기의 루틴만큼 엄마의 루틴도 중요하다는 걸 기억해주세요.\n\n-오늘 아내가 씻을 시간은 있었나요?\n\n-밥은 따뜻하게 먹었나요?\n\n-아무 말 없이 쉬는 시간이 10분이라도 있었나요?",
          },
          {
            subTitle: "오늘 하루 아빠 미션",
            discribed:
              "'나는 오늘 아내의 '회복 루틴'을 하나 도왔는가?'\n\n아내가 '돌봄'만 하는 하루가 되지 않도록, '회복'할 수 있는 하루가 되도록 곁을 지켜주세요.",
          },
        ],
      },
    },
    {
      day: 20,
      mom: {
        head: {
          title: "이제야 조금, 감이 와요",
          discribed: "",
        },
        body: [
          {
            subTitle: "산후 회복은 개인의 속도",
            discribed:
              "3주쯤 지나면 엄마의 몸도 조금씩 안정을 찾아가요.\n\n그래도 아직은 '완전히 회복된 것 같진 않다'는 느낌, 들죠?\n\n다른 엄마들과 비교하지 마세요.\n\n어떤 엄마는 이 시기에 외출도 하고, 어떤 엄마는 아직 누워 있어요.\n\n몸이 보내는 신호에 귀 기울이세요.\n\n'조금 더 쉬어야겠다'는 느낌이 있다면 쉬어야 할 타이밍이에요.",
          },
          {
            subTitle: "모유수유·분유수유가 조금 더 익숙해져요",
            discribed:
              "유두 통증, 젖몸살이 서서히 줄어들 수 있어요.\n\n분유 수유 중이라면 아기와 눈 맞춤을 통해 교감해 주세요.\n\n수유 자세, 시간, 트림 루틴도 조금씩 편안해지고 있지 않나요?",
          },
          {
            subTitle: "격려",
            discribed:
              "3주 동안 정말 잘 버텨왔어요.\n\n오늘도 '나는 충분히 잘하고 있다'고 스스로에게 말해주세요.",
          },
        ],
      },
      baby: {
        head: {
          title: "나는 지금 자라나는 중이에요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "울음의 구분",
            discribed:
              "아기의 수유, 수면, 배변, 울음이 조금씩 예측 가능해지기 시작해요.\n\n이 시기 특징은 '울음의 구분'이 생긴다는 것!\n\n배고플 때 우는 울음, 졸릴 때 우는 울음, 불편할 때 울음.\n\n이제 엄마 아빠는 슬슬 이 울음을 '구별'할 수 있게 돼요.\n\n맞아요. 그게 육아의 시작이에요.",
          },
          {
            subTitle: "터미타임, 아기 마사지 시작해보세요!",
            discribed:
              "배에 손을 얹고 살살 돌려주는 마사지, 수유 후, 살짝 엎드리게 해주는 연습도 좋아요 (단, 절대 혼자 두지 않기!)",
          },
          {
            subTitle: "성장의 기록",
            discribed:
              "아기는 '조금씩' 자라고 있어요.\n\n크게 보이진 않아도, 매일매일 달라지고 있어요.",
          },
        ],
      },
      dad: {
        head: {
          title: "이제는 팀워크의 시간이에요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "'아빠표 루틴'을 만들어보세요!",
            discribed:
              "이제 아빠도 아기에게 점점 익숙해지고 있죠?\n\n아빠가 아기를 목욕시키거나, 수유 후 트림 도우미가 되거나, 저녁 시간대 산책을 담당하는 것도 좋아요.\n\n아기의 기억에는 '엄마의 품'과 함께 '아빠의 손길'도 함께 새겨질 거예요.",
          },
          {
            subTitle: "격려의 말",
            discribed:
              "그리고 오늘 아내에게 꼭 한 마디: '지금까지도 정말 잘해왔고, 앞으로도 잘 할 수 있을 거야.'",
          },
        ],
      },
    },
    {
      day: 24,
      mom: {
        head: {
          title: "한 달이 다 되어가요",
          discribed: "",
        },
        body: [
          {
            subTitle: "몸의 회복은 '이제 시작'이에요",
            discribed:
              "벌써 출산 후 4주차! 믿기지 않죠?\n\n매일 반복된 육아 속에서도, 엄마는 매일 자라고 있어요.\n\n제왕절개나 회음부 회복, 아직 욱신거릴 수 있어요.\n\n오래 앉아있으면 허리와 골반이 불편할 수 있어요.\n\n몸을 조금씩 움직이되, 무리하지 마세요.",
          },
          {
            subTitle: "수유 피로가 누적되는 시기",
            discribed:
              "수유 중이라면 어깨, 손목, 손가락 관절이 아플 수 있어요.\n\n간단한 스트레칭이나 파스, 온찜질로 근육을 풀어주세요.\n\n수유쿠션, 손목 보호대도 활용해보세요.",
          },
          {
            subTitle: "새로운 시작",
            discribed:
              "이제부터는 엄마 자신을 위한 시간도 조금씩 가져보는 연습이 필요해요.\n\n'나는 아기와 함께 다시 태어나는 중이야' 이 한마디, 기억해 주세요.",
          },
        ],
      },
      baby: {
        head: {
          title: "이제 한 달을 향해 가는 중이에요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "하루 패턴이 조금 더 명확해져요",
            discribed:
              "생후 4주, 아기에게도 첫 번째 전환점이 되는 시기입니다.\n\n수유 주기: 2~3시간 간격, 수면 시간: 하루 평균 15~18시간, 트림, 방귀, 대변 빈도도 조금씩 일정해져요.",
          },
          {
            subTitle: "아기에게 말을 걸어주세요",
            discribed:
              "엄마 아빠의 말을 들으며 '언어 감각'이 자라나요.\n\n'우리 아기 눈 떴네~', '지금 기분이 어때?' 같은 말도 좋아요.\n\n말은 이해하지 못해도 음성의 리듬과 감정은 그대로 느껴요.",
          },
          {
            subTitle: "성장의 증거",
            discribed:
              "아기는 보이지 않게 매일 성장 중이에요.\n\n지금 이 순간도 아기의 뇌는 연결되고, 발달하고 있어요.",
          },
        ],
      },
      dad: {
        head: {
          title: "우리 팀, 잘 가고 있어요",
          discribed: "",
        },
        body: [
          {
            subTitle: "아기와 보내는 단독 시간, 늘려보세요",
            discribed:
              "이제 아빠도 슬슬 육아에 리듬이 생겼을 거예요.\n\n목욕시키기, 안아주기, 재우기.\n\n짧은 10~15분이라도 좋으니, '오롯이 둘이만' 있는 시간을 가져보세요.",
          },
          {
            subTitle: "엄마의 말, 경청하기",
            discribed:
              "지금 엄마는 정신적으로 가장 예민한 시기예요.\n\n조언보다는 '그랬구나', '고생 많았겠다'와 같은 공감의 언어가 더 큰 힘이 돼요.",
          },
          {
            subTitle: "팀워크",
            discribed:
              "우리 팀, 지금 아주 잘하고 있어요.\n\n모두가 낯선 시간 속에서 조금씩 적응해가는 중이에요.",
          },
        ],
      },
    },
    {
      day: 28,
      mom: {
        head: {
          title: "이제 진짜 한 달을 채웠어요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "한 달의 성과",
            discribed:
              "출산 후 한 달, 엄마 정말 고생 많았어요.\n\n몸은 완전히 회복되지 않았고, 수면도 부족한 날들이었죠.\n\n하지만 지금의 나는 한 달 전과 완전히 달라요.",
          },
          {
            subTitle: "산후조리 마지막 점검 포인트",
            discribed:
              "회음부/수술부위 통증은 괜찮나요?\n\n오로(혈성 분비물)의 양은 많이 줄었나요?\n\n유방 통증이나 이상은 없나요?\n\n지금부터는 회복과 더불어 내 몸을 한 번 더 점검하고 다독여주는 시간이 필요해요.",
          },
          {
            subTitle: "잊지 마세요, 산후검진!",
            discribed:
              "출산 4~6주 사이에 진행되는 산후 1개월 검진, 꼭 받으셔야 해요.\n\n자연분만 산모는 회음부 회복과 자궁 수축 상태, 분비물, 유방 상태 등을 점검하고 제왕절개 산모는 수술 부위 회복 상태, 통증, 감염 여부 등을 확인하게 돼요.\n\n또한, 산후 우울감이나 정서적인 변화, 수유 고민이나 피임에 대한 상담도 함께 이뤄질 수 있어요.\n\n아직 검진 예약하지 않았다면, 이번 주 안에 꼭 병원 일정 잡아보세요.",
          },
          {
            subTitle: "새로운 나",
            discribed:
              "출산 전의 '나'는 아니지만, 지금의 나는 아기를 품고 있는 강하고 단단한 나예요.\n\n이 한 달, 당신이 해낸 모든 걸 꼭 기억해주세요.",
          },
        ],
      },
      baby: {
        head: {
          title: "생애 첫 번째 달, 완주했어요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "첫 달의 성과",
            discribed: "생후 28일, 아기의 첫 번째 '마라톤'이 끝났어요.",
          },
          {
            subTitle: "생후 1개월, 이런 모습이 보이나요?",
            discribed:
              "시선을 잠깐 맞추기도 하고, 엄마의 냄새나 목소리에 더 반응하고, 손을 꽉 쥐고 있던 주먹을 슬슬 펴기도 해요.",
          },
          {
            subTitle: "돌연사의 예방 포인트",
            discribed:
              "배가 아닌 등을 대고 눕혀 재우기, 너무 두껍거나 복잡한 이불은 사용하지 않기, 수면 시 옆에서 지켜봐주는 습관도 중요해요.",
          },
          {
            subTitle: "성장의 기적",
            discribed:
              "오늘도 아기는 조용히, 놀라울 만큼 빠르게 성장 중이에요.\n\n'첫 달을 무사히 지났어요! 고마워요, 엄마 아빠.'",
          },
        ],
      },
      dad: {
        head: {
          title: "한 달, 해냈어요!",
          discribed: "",
        },
        body: [
          {
            subTitle: "'정답 같은 아빠상'은 없어요",
            discribed:
              "아빠에게도 처음이었던 한 달, 어떠셨나요?\n\nTV 속 멋진 아빠, 책에서 본 이상적인 모습보다 우리 가족에게 가장 필요한 모습이 바로 '좋은 아빠'예요.\n\n기저귀를 갈고, 밤에 아기를 안고, 아내의 마음에 귀 기울이는 지금의 당신, 그 자체로 충분히 훌륭해요.",
          },
          {
            subTitle: "이제는 아빠도 감정을 나눌 때",
            discribed:
              "힘들었다면, 어렵다면, 그렇게 말해주세요.\n\n서로의 감정을 나눌수록 더 튼튼한 팀이 된답니다.",
          },
          {
            subTitle: "새로운 시작",
            discribed:
              "출산 후 한 달.\n\n이제 아기와 함께 '진짜 육아'가 시작됩니다.\n\n고생 많았어요.\n\n이제 2개월을 향해 힘차게 나아가볼까요?",
          },
        ],
      },
    },
    {
      day: 35,
      mom: {
        head: {
          title: "산후 5주차, 이제 일상이 되어가고 있어요",
          discribed: "",
        },
        body: [
          {
            subTitle: "리듬 형성",
            discribed:
              "벌써 5주가 지났어요.\n\n처음엔 모든 게 낯설고 서툴기만 했던 하루하루가 조금씩 '우리 가족의 리듬'을 만들어가고 있어요.",
          },
          {
            subTitle: "몸은 거의 회복되었지만…",
            discribed:
              "자연분만의 경우 대부분의 신체 회복이 이루어지는 시기지만, 무리하지 않는 일상 복귀가 중요해요.\n\n산후 출혈, 요통, 손목통증, 골반통 등 남아있는 불편함이 있다면 간과하지 말고 진료나 물리치료를 고려해 주세요.\n\n제왕절개 산모는 상처 부위가 간질거리거나 당기는 느낌이 생길 수 있어요.\n\n가벼운 스트레칭부터 시작해보세요.",
          },
          {
            subTitle: "'나'를 돌보는 시간도 필요해요",
            discribed:
              "이제는 하루 10분이라도 온전히 나를 위한 시간을 가져보세요.\n\n산책, 스트레칭, 책 한 페이지, 따뜻한 차 한잔도 좋아요.\n\n육아에 올인하고 있는 자신에게 작은 숨구멍을 만들어 주세요.",
          },
        ],
      },
      baby: {
        head: {
          title: "애착이 자라는 시간",
          discribed: "",
        },
        body: [
          {
            subTitle: "정서적 기초 형성",
            discribed:
              "이 시기의 아기는 엄마의 눈빛, 손길, 말투 하나하나에 익숙해지고 있어요.\n\n지금은 아기의 정서적 기초가 형성되는 시기!\n\n울음을 참지 말고, 안아주세요.\n\n'응답받는 경험'은 아기의 자존감과 신뢰의 기초가 됩니다.",
          },
        ],
      },
      dad: {
        head: {
          title: "이제는 생활이 되었나요?",
          discribed: "",
        },
        body: [
          {
            subTitle: "루틴의 중요성",
            discribed:
              "5주, 이제는 조금 루틴이 생기셨나요?\n\n하루 중 단 10분이라도 아기와만 보내는 시간, 아내가 나만 보면 쉴 수 있는 짧은 틈, 이 두 가지만 만들어도 가족 모두에게 여유가 생겨요.",
          },
          {
            subTitle: "응원",
            discribed:
              "아기와 함께 보내는 매일이 조금은 덜 힘들고, 조금은 더 즐겁도록 아빠의 손길과 마음이 더해지길 응원해요.",
          },
        ],
      },
    },
    {
      day: 42,
      mom: {
        head: {
          title: "6주, 긴 여정을 마무리하며",
          discribed: "",
        },
        body: [
          {
            subTitle: "6주간의 성과",
            discribed:
              "벌써 출산 후 6주가 지났어요.\n\n엄마, 정말 수고 많으셨어요.\n\n이제 본격적인 회복기의 끝자락에 와 있어요.\n\n그동안의 시간들이 얼마나 치열했는지 스스로를 꼭 안아주세요.",
          },
          {
            subTitle: "산후 6주 검진, 받으셨나요?",
            discribed:
              "대부분의 산후검진은 출산 후 4~6주 사이에 이뤄져요.\n\n아직 못 받으셨다면 지금이라도 병원에 꼭 방문해 주세요.\n\n검진에서는 다음을 확인하게 돼요:\n\n-자궁이 임신 전 크기로 잘 돌아왔는지\n\n-회음부 또는 수술 부위의 회복 상태\n\n-유방, 유즙 분비 상태\n\n-월경 재개 여부\n\n-정신적·정서적 상태\n\n-필요시 피임 상담",
          },
          {
            subTitle: "지속적인 관리",
            discribed:
              "산후 우울감이나 수유 문제, 수면 부족이 계속된다면 그대로 참고 넘기지 말고 꼭 의료진과 상의하세요.",
          },
          {
            subTitle: "새로운 균형 찾기",
            discribed:
              "이제부터는 새로운 균형을 찾아야 할 시간이에요.\n\n엄마의 몸과 마음은 아직 회복 중이지만, 이제 조금씩 '나'의 삶도 다시 만들어가야 해요.\n\n건강한 식사, 충분한 휴식, 가벼운 운동, 대화와 감정 표현.\n\n이 작은 실천들이 엄마의 일상 회복에 큰 힘이 될 거예요.",
          },
          {
            subTitle: "격려와 응원",
            discribed:
              "엄마, 정말 잘 해내셨어요.\n\n이제는 스스로에게도 따뜻한 응원을 건네주세요.\n\n앞으로 펼쳐질 일상 속에서 엄마도, 아기도 한층 더 단단해질 거예요.",
          },
        ],
      },
      baby: {
        head: {
          title: "이제 나는 6주차 아기!",
          discribed: "",
        },
        body: [
          {
            subTitle: "6주간의 성장",
            discribed:
              "엄마와 함께 세상에 나온 지 벌써 6주!\n\n이제 나는 낮과 밤을 조금씩 구분할 수 있어요.\n\n가끔 밤에는 오래 자고, 낮에는 자주 깰 수도 있죠.\n\n아직은 서툴지만 하루하루 눈에 띄게 성장하고 있어요!",
          },
          {
            subTitle: "나의 변화 포인트",
            discribed:
              "수유 텀이 조금씩 길어지고 있어요.\n\n초점이 맞는 시간이 늘어나고, 엄마 아빠 얼굴을 따라보기도 해요.\n\n미소를 짓기도 하고, 옹알이 비슷한 소리를 내기 시작했어요.\n\n손을 쥐거나 팔을 휘젓는 움직임이 더 활발해졌어요.",
          },
          {
            subTitle: "수면 패턴",
            discribed:
              "수면은 여전히 불규칙하지만 잠들기 전 루틴(예: 조용한 목소리, 어두운 조명)을 만들어주면 조금씩 안정감을 느끼고 편히 잘 수 있어요.",
          },
          {
            subTitle: "성장의 기록",
            discribed:
              "나도 하루하루 나아지고 있어요!\n\n천천히, 단단하게 커나가고 있으니까 오늘도 나를 따뜻하게 안아주세요!",
          },
        ],
      },
      dad: {
        head: {
          title: "아빠도 지금, 아주 중요한 시기예요",
          discribed: "",
        },
        body: [
          {
            subTitle: "6주간의 여정",
            discribed:
              "6주, 시간이 정말 빠르죠?\n\n그동안 아내와 아기를 돌보느라 정말 열심히 달려오셨어요.\n\n이제는 회복기의 마지막, 그리고 새로운 일상의 시작을 준비할 때입니다.",
          },
          {
            subTitle: "아빠가 해줄 수 있는 것들",
            discribed:
              "산후검진 시 함께 동행하거나 검진 내용에 대해 관심 갖고 질문해 주세요.\n\n아내의 수면 시간을 확보해주기 위해 수유 직후 아기와 함께 놀아주기, 안아주기.\n\n아기의 변화를 함께 관찰하고 기록해보세요. (예: 첫 미소, 눈 마주침, 옹알이 소리 등)",
          },
          {
            subTitle: "부부 관계 회복",
            discribed:
              "부부 사이도 다시 정돈할 시기예요.\n\n출산 직후엔 부모로서의 역할이 중심이었다면 이제는 다시 '파트너'로서의 관계도 회복해야 할 시간이에요.\n\n따뜻한 말 한마디, 짧은 포옹이 아내에게 큰 힘이 됩니다.",
          },
          {
            subTitle: "마라톤의 시작",
            discribed:
              "'육아는 함께 가는 마라톤' 아직 초반이에요.\n\n당신의 참여가 엄마에게도 아기에게도 커다란 안정감을 준다는 사실, 잊지 마세요!",
          },
        ],
      },
    },
  ],
};

export default postBirthData;
